export const raptorJobRestEndpoints = {
  // Real API endpoints
  createMultiDayJob: '/api/v3/raptor-jobs/create-multi-day-job',
  createSingleDayJob: '/api/v3/raptor-jobs/create-single-day-job',
  getJob: '/api/v3/raptor-jobs',
  getJobById: '/api/v3/raptor-jobs',
  cancelJob: '/api/v3/raptor-jobs',

  // Mock API endpoints
  mockRaptorJobs: '/api/raptorJobs',
  mockJobs: '/raptorJobs',
  mockJobById: '/raptorJobs',
  mockCancelJob: '/raptorJobs'
} as const;
export const raptorTicketsRestEndpoints = {
  createTicket: '/api/v3/raptor-tickets',
  mockTickets: '/api/raptorTickets'
} as const;
